module.exports = __webpack_public_path__ + "img/Retail19.ff925a0b.png";